import React from 'react'
import Header from '../components/Header'
import { Footer } from '../components/Footer'
import PatientRelativesSubmitDetailInformationPage from '../views/patientInformation/PatientRelativesSubmitDetailInformationPage'

const PatientRelativesSubmitDetailInformation = () => {
    window.scrollTo(0, 0);

    return (
        <>
            <Header />
            < PatientRelativesSubmitDetailInformationPage />
            <Footer />
        </>
    )
}

export default PatientRelativesSubmitDetailInformation
